module.exports = __webpack_public_path__ + "static/media/whatsapp.78cfc76e.svg";